<template>
    <section>
        <div class="idea-vision">
            <scroll-parallax :speed="0.1">
                <BackgroundImage image="idea-vision" position="center" />
            </scroll-parallax>
            <div class="container">
                <scroll-parallax :speed="0.15">
                    <div class="idea-vision__header">
                        <h2>Idé & <span>Vision</span></h2>
                        <div class="idea-vision__quote">
                            <Quote
                                text="Vi har varit delaktiga i utvecklingen av två generationer butiksbackoffice och utvecklat självscanning för nordiska föhållanden och köpbeteenden sedan 2004"
                            />
                        </div>
                    </div>
                </scroll-parallax>
            </div>
            <div class="idea-vision__content">
                <Animate>
                    <div class="container">
                        <div class="idea-vision__content-idea">
                            <img
                                src="../assets/icons/idea-vision-idea-icon.svg"
                                alt="Icon of a light bulb lit up"
                            />
                            <div class="idea-vision__content-idea--text">
                                <p>
                                    <span>Vår idé</span> är att jobba fokuserat
                                    mot detaljhandeln utveckla mjukvaror och
                                    bistå med know-how som förenklar vardagen på
                                    butiksgolvet, effektiviserar butiksprocesser
                                    samt bidrar till ökad lönsamhet för handeln
                                    oavsett kanal.
                                </p>
                                <p>
                                    <span>Vi gör det</span> genom att nyttja
                                    vårt gedigna kunnande av såväl teknik som
                                    detaljhandel. Ibland kombinerat med vårt
                                    genom åren upparbetade kontaktnät av
                                    utvecklare och hårdvarufabrikanter som kan
                                    bidraga till de bästa lösningarna för olika
                                    befintliga och kommande utmaningar för vår
                                    kunders verksamhet inom detaljhandeln
                                </p>
                            </div>
                        </div>
                        <div class="idea-vision__content-vision">
                            <div class="idea-vision__content-vision--left-text">
                                <p>
                                    <span>Vår vision</span> är att förbättra
                                    lönsamheten för detaljhandeln, gör
                                    butiksprocesser effektivare och göra livet
                                    enklare för butiksmedarbetare genom att vara
                                    den trevligaste och mest efterfrågade
                                    leverantören av IT-system inom detaljhandel.
                                </p>
                            </div>
                            <img
                                src="../assets/icons/idea-vision-vision-icon.svg"
                                alt="Icon of a light bulb lit up"
                            />
                            <div
                                class="idea-vision__content-vision--right-text"
                            >
                                <p>
                                    <span>Vårt arbete</span> styrs av
                                    kostnadseffektivitet i alla led, en
                                    leveranssäkerhet med hjärta och hjärna och
                                    vi ska leva och verka nära detaljhandelns
                                    viktigaste aktörer.
                                </p>
                            </div>
                        </div>
                    </div>
                </Animate>

                <Animate>
                    <div class="idea-vision__content-guiding-stars">
                        <div class="container">
                            <div
                                class="idea-vision__content-guiding-stars-grid"
                            >
                                <div
                                    class="idea-vision__content-guiding-stars-grid--box"
                                >
                                    <img
                                        src="../assets/icons/idea-vision-challenge-icon.svg"
                                    />
                                    <p>Vi <span>utmanar</span></p>
                                </div>
                                <div
                                    class="idea-vision__content-guiding-stars-grid--box"
                                >
                                    <img
                                        src="../assets/icons/idea-vision-honest-icon.svg"
                                    />
                                    <p>Vi är <span>ärliga</span></p>
                                </div>
                                <div
                                    class="idea-vision__content-guiding-stars-grid--box"
                                >
                                    <img
                                        src="../assets/icons/idea-vision-expert-icon.svg"
                                    />
                                    <p>Vi är <span>experter</span></p>
                                </div>
                                <div
                                    class="idea-vision__content-guiding-stars-grid--box"
                                >
                                    <img
                                        src="../assets/icons/idea-vision-cooperate-icon.svg"
                                    />
                                    <p>Vi <span>samarbetar</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Animate>

                <Animate>
                    <div class="container">
                        <div class="idea-vision__content-trailer">
                            <h4>
                                Vill du höra mer av
                                <span>vad vi har att erbjuda?</span>
                            </h4>
                            <p>
                                Kolla in våra
                                <router-link to="services"
                                    >tjänster</router-link
                                >
                                eller kontakta oss gärna för att prata mer om
                                vad vi kan göra för er. Antingen via vårt
                                <router-link to="contact"
                                    >kontaktformulär</router-link
                                >
                                eller direkt via e-post på
                                <a href="mailto:info@retailonly.se"
                                    >info@retailonly.se</a
                                >
                            </p>
                            <p>
                                Ni kan också titta in och följa våra sidor på
                                <a
                                    href="https://www.facebook.com/Retail-Only-465857273847638/"
                                    target="_blank"
                                    >Facebook</a
                                >
                                och
                                <a
                                    href="https://www.linkedin.com/company/retail-only-i-sverige-ab/"
                                    target="_blank"
                                    >LinkedIn</a
                                >
                                där vi postar nyheter och sådant vi håller på
                                med just nu.
                            </p>
                        </div>
                    </div>
                </Animate>
            </div>
        </div>
    </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ScrollParallax from 'vue3-parallax/src/components/ScrollParallax.vue'

import BackgroundImage from '@/components/Common/BackgroundImage.vue'
import Quote from '@/components/Common/Quote.vue'
import Animate from '@/components/Common/Animate.vue'

export default defineComponent({
    name: 'Idea-Vision',
    components: {
        ScrollParallax,
        BackgroundImage,
        Quote,
        Animate,
    },
})
</script>

<style lang="scss" scoped>
@import '../styles/variables';
@import '../styles/mixins';
@import '../styles/config';

.idea-vision {
    position: relative;

    &__header {
        position: relative;
        padding-top: 20vh;
        height: 80vh;
        z-index: 10;

        @include mQ(700px) {
            padding-top: 18vh;
            text-align: center;
        }
    }

    &__quote {
        z-index: 20;
    }

    &__content {
        width: 100%;
        padding: 10rem 0 6rem 0;
        position: relative;
        z-index: 5;

        @include mQ(700px) {
            padding: 6rem 0 4rem 0;
        }

        &-idea {
            display: grid;
            grid-template-columns: 1fr 4fr;
            padding: 0 2rem;
            margin-bottom: 3rem;

            @include mQ(550px) {
                grid-template-columns: 1fr;
                justify-items: center;
                gap: 1rem;
                padding: 0 0;
            }

            &--text {
                margin-left: 2rem;
                display: flex;
                flex-direction: column;
                align-items: center;

                @include mQ(550px) {
                    margin-left: 0;
                }

                p:first-of-type {
                    margin-bottom: 1rem;
                }

                p span {
                    font-weight: 700;
                }
            }
        }

        &-vision {
            display: grid;
            grid-template-columns: 2fr 1fr 2fr;
            justify-content: center;
            align-items: center;
            padding: 0 2rem;

            @include mQ(550px) {
                grid-template-columns: 1fr;
                justify-items: center;
                gap: 1rem;
                padding: 0;
                margin: 0;
            }

            &--left-text,
            &--right-text {
                span {
                    font-weight: 700;
                }
            }

            & img {
                margin: 0 1rem;

                @include mQ(550px) {
                    grid-row: 1 / 2;
                }
            }
        }

        &-guiding-stars {
            margin-top: 4rem;
            // background-color: lighten($accent-color-very-light, 4%);
            background: linear-gradient(
                to bottom right,
                #fff,
                lighten($accent-color-very-light, 3%)
            );
            padding: 2rem 0;

            &-grid {
                display: grid;
                grid-template-columns: repeat(4, 1fr);
                gap: 1rem;

                @include mQ(900px) {
                    grid-template-columns: 1fr 1fr;
                    width: 80%;
                    margin: 0 auto;
                }

                @include mQ(550px) {
                    gap: 2rem;
                }

                &--box {
                    align-self: center;
                    justify-self: center;

                    @include mQ(900px) {
                        img {
                            width: 150px;
                        }
                    }

                    @include mQ(550px) {
                        img {
                            width: 100px;
                        }
                    }

                    p {
                        font-family: $font-family-header;
                        text-align: center;

                        span {
                            font-weight: 700;
                        }
                    }
                }
            }
        }

        &-trailer {
            max-width: 80%;
            margin: 0 auto;
            padding-top: 6rem;
            text-align: center;

            @include mQ(750px) {
                max-width: 100%;
                padding-top: 4rem;
            }

            p {
                max-width: 80%;
                margin: 0 auto;

                @include mQ(750px) {
                    max-width: 100%;
                }
            }

            p:first-of-type {
                margin-bottom: 1rem;
            }

            p a {
                color: $accent-color;
            }
        }
    }
}
</style>
